export const COPILOT_INITIALIZE_OPEN = 'copilot-initialize-open';